export const ROUTES = {
  COMUNICACAO: '/comunicacao',
  COMUNICACAO_NOTICIAS: '/comunicacao/noticias',
  SERVICOS: '/servicos',
  MINHAS_PENDENCIAS: '/minhas-pendencias',
  PENDENCIAS_LEGADAS: '/pendencias-legadas',
  AUDITAR_ACERVO: '/auditar-acervo',
  NOTIFICACOES: '/notificacoes',
  CONTROLPANEL_VERSAO: '/controlpanel/mpf-version-profile',
  CONTROLPANEL_PERMISSOES: '/controlpanel/mpf-permissoes',
} as const;

/**
 * Filtros da listagem de notícias que trafegam na querystring — é o que torna
 * a busca compartilhável e sobrevivente a F5, e o que o botão do bloco
 * "Notícias por tema" preenche ao mandar o leitor para a lista completa.
 * `b_start` (paginação) é tratado à parte, em `useNewsListing`.
 */
export const NEWS_FILTER_PARAMS = {
  tema: 'tema',
  unidade: 'unidade',
  searchableText: 'q',
  sortOrder: 'sort_order',
  dataInicio: 'data_inicio',
  dataFim: 'data_fim',
} as const;
